import { createRequestTypes } from '../../utils';

export const LOAD_MODAL_DATA = createRequestTypes('shadeXRmModal/LOAD_MODAL_DATA');